import cn from 'classnames';
import type { ReactNode } from 'react';
import { Col } from 'ui';

export type ColumnProperties = {
  children: ReactNode;
  className?: string;
  offsetTop?: 'default';
  space?: SpaceOptions;
  widthMode?: 'default' | 'small' | 'stretch';
};

type SpaceOptions = {
  position?: 'left' | 'right';
  size?: boolean | SpaceSize;
};

type SpaceSize = 'lg' | 'md' | 'sm';

const defaultSpaceProperties: SpaceOptions = {};

const Column = ({
  children,
  className,
  offsetTop,
  space: { position = 'left', size } = defaultSpaceProperties,
  widthMode = 'default',
}: ColumnProperties) => {
  const finalSize = size === true ? 'md' : size;

  return (
    <Col
      className={cn(className, 'layout-column', {
        'layout-column--left--lg': finalSize === 'lg' && position === 'left',
        'layout-column--left--md': finalSize === 'md' && position === 'left',
        'layout-column--left--sm': finalSize === 'sm' && position === 'left',
        'layout-column--offset-top--default': offsetTop === 'default',
        'layout-column--right--lg': finalSize === 'lg' && position === 'right',
        'layout-column--right--md': finalSize === 'md' && position === 'right',
        'layout-column--right--sm': finalSize === 'sm' && position === 'right',
        'layout-column--width-mode--default': widthMode === 'default',
        'layout-column--width-mode--small': widthMode === 'small',
        'layout-column--width-mode--stretch': widthMode === 'stretch',
      })}
    >
      {children}
    </Col>
  );
};

export default Column;
